import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import PendingSurveyCard from '../components/PendingSurveyCard';
import { getPendigSurveyAPI } from '../api/pendingSurveyAPI';
import { SurveyItem } from '../types/index.ts'

export default function PendingSurveys() {
    //const [loading, setLoading] = useState(true);
    const [pendingSurveys, setPendingSurveys] = useState<SurveyItem[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await searchPendingSurvey();
            } catch (error) {
                console.error(error);
                 
            } finally {
               console.log("loaded");
            }
        }

        fetchData()
    }, [])


    const searchPendingSurvey = () => {
        
        getPendigSurveyAPI()
            .then(response => {
                setPendingSurveys(Array.isArray(response) ? response : []);
            })
            .catch(error => {
                console.error('Error fetching pending surveys', error);
        });
  
    }

    return (
        <Container>
            {pendingSurveys.map((survey) => (
                <Row key={survey.id}  className="p-3 d-flex justify-content-start p-0"  >
                    <Col>
                        <PendingSurveyCard survey={survey} />
                    </Col>
                </Row>
            ))}
            
        </Container>

               
    );
   
   
}